/* unplugin-vue-components disabled */import { render } from "./swiperTeacherList.vue?vue&type=template&id=fa12f9c0&scoped=true"
import script from "./swiperTeacherList.vue?vue&type=script&lang=js"
export * from "./swiperTeacherList.vue?vue&type=script&lang=js"

import "./swiperTeacherList.vue?vue&type=style&index=0&id=fa12f9c0&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa12f9c0"]])

export default __exports__